import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=54561666&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./BannerCarousel.vue?vue&type=style&index=0&id=54561666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54561666",
  null
  
)

export default component.exports